































































































import TabsZone from "@/components/tabs/zone.vue";
import { zoneService } from "@/services/zone";
import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import { Zone } from "@/swagger/models";
import { Committable, WrapService } from "@/plugins/committable";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import Card from "@/components/layout/card.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import { subject } from "@casl/ability";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "zone",
    components: { TabsZone, PageHeader, Card, CommitResetBar, Page },
})
export default class ZoneView extends Vue {
    committable: Committable<Zone>;

    // nextId: number = null;
    // previousId: number = null;

    zoneTypes = [
        { label: "Work area", value: "workArea" },
        { label: "Meeting room", value: "meetingRoom" },
        { label: "Canteen", value: "canteen" },
        { label: "Gym", value: "gym" },
        { label: "Lounge", value: "lounge" },
        { label: "Parking", value: "parking" },
    ];

    async created() {
        try {
            this.committable = new Committable<Zone>({
                onCommit: WrapService(zoneService, {
                    ignoredFields: ["deletedAt"],
                    routeIdParam: "zoneId",
                    router: this.$router,
                }),
            });

            if (this.$route.params.zoneId === "new") {
                this.committable.set(
                    zoneService.build({
                        floorId: parseInt(this.$route.params.floorId),
                    }),
                );
            } else {
                const res = await zoneService.getNew(parseInt(this.$route.params.zoneId));
                this.committable.set(res.data);
                // this.previousId = res.previousId;
                // this.nextId = res.nextId;
            }
        } catch (e) {
            console.warn(e);
            await this.$router.back();
        }
    }

    get canEdit() {
        if (this.committable.loading.value) return false;
        // @ts-ignore
        if (this.$route.params.zoneId === "new" && this.$can("create", "Zone")) return true;
        // @ts-ignore
        else if (this.$can("update", subject("Zone", this.committable?.original?.value))) return true;
        return false;
    }

    async deleteZone() {
        if (!this.committable.original.value.id) return;
        if (!confirm("Are you sure you want to delete this zone?")) return;
        await zoneService.delete(this.committable.original.value.id);
        await this.$router.replace({ name: "floor" });
    }
}
